import { render, staticRenderFns } from "./FooterContactUs.vue?vue&type=template&id=26140187&scoped=true&"
import script from "./FooterContactUs.vue?vue&type=script&lang=ts&"
export * from "./FooterContactUs.vue?vue&type=script&lang=ts&"
import style0 from "./FooterContactUs.vue?vue&type=style&index=0&id=26140187&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26140187",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('/opt/atlassian/pipelines/agent/build/components/Footer.vue').default})
